import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var MoreHorizontalFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M12 22a6 6 0 1 1-12 0 6 6 0 0 1 12 0ZM28 22a6 6 0 1 1-12 0 6 6 0 0 1 12 0ZM44 22a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z"
  }));
});
MoreHorizontalFill.displayName = 'MoreHorizontalFill';
MoreHorizontalFill.defaultProps = {
  'aria-label': 'MoreHorizontalFill'
};
export default MoreHorizontalFill;